import EthernetIcon from '../../../../../components/ui-icons/ethernet'

const DefrouteItem = () => {
  return <EthernetIcon aria-label="Connected to Ethernet" />
}

export default DefrouteItem
